class PotPicker extends HTMLElement {
  constructor() {
    super();
    this.preview = this.querySelector('[data-pot-preview]');
    this.selected = this.querySelector('[data-pot-selected]');
    this.drawer = this.querySelector('[data-pot-drawer]');
    this.applyBtn = this.querySelector('[data-pot-apply]');
    this.addBtn = this.querySelector('[data-pot-add]');
    this.cards = Array.from(this.querySelectorAll('[data-pot-drawer] [data-pot-card]'));
    this.miniCart = document.querySelector('mini-cart');

    this.pendingCard = null; // highlighted in the drawer, not yet applied
    this.currentCard = null; // applied selection

    this.onKeydown = this.onKeydown.bind(this);
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    // Move the drawer to <body> so its position:fixed is relative to the
    // viewport. A transformed/sticky ancestor in the product column would
    // otherwise become the containing block and trap the overlay + panel.
    if (this.drawer && this.drawer.parentElement !== document.body) {
      document.body.appendChild(this.drawer);
    }

    this.preview.addEventListener('click', (event) => {
      if (event.target.closest('[data-pot-card], [data-pot-open]')) this.openDrawer();
    });

    this.selected.addEventListener('click', (event) => {
      if (event.target.closest('[data-pot-change]')) {
        this.openDrawer();
      } else if (event.target.closest('[data-pot-remove]')) {
        this.deselect();
      } else if (event.target.closest('[data-pot-add]')) {
        this.addToCart();
      }
    });

    this.drawer.addEventListener('click', (event) => {
      if (event.target.closest('[data-pot-close]')) {
        this.closeDrawer();
        return;
      }
      const card = event.target.closest('[data-pot-card]');
      if (card && card.dataset.available !== 'false') this.selectInDrawer(card);
    });

    this.selected.addEventListener('change', (event) => {
      if (event.target.closest('[data-pot-selected-variant]')) this.syncSelectedVariant();
    });

    this.applyBtn.addEventListener('click', () => this.apply());
  }

  disconnectedCallback() {
    if (this.drawer && this.drawer.parentElement === document.body) {
      this.drawer.remove();
    }
    document.removeEventListener('keydown', this.onKeydown);
    document.body.classList.remove('pot-picker-open');
  }

  onKeydown(event) {
    if (event.key === 'Escape') this.closeDrawer();
  }

  openDrawer() {
    this.pendingCard = this.currentCard;
    this.cards.forEach((card) => card.classList.toggle('is-selected', card === this.currentCard));
    this.applyBtn.disabled = !this.pendingCard;

    this.drawer.classList.add('is-open');
    this.drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pot-picker-open');
    document.addEventListener('keydown', this.onKeydown);
  }

  closeDrawer() {
    this.drawer.classList.remove('is-open');
    this.drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pot-picker-open');
    document.removeEventListener('keydown', this.onKeydown);
  }

  selectInDrawer(card) {
    this.pendingCard = card;
    this.cards.forEach((item) => item.classList.toggle('is-selected', item === card));
    this.applyBtn.disabled = false;
  }

  syncSelectedVariant() {
    const priceSlot = this.selected.querySelector('[data-pot-selected-price]');
    const select = this.selected.querySelector('[data-pot-selected-variant] select');
    if (select && select.options[select.selectedIndex]) {
      const option = select.options[select.selectedIndex];
      priceSlot.textContent = option.dataset.price || '';
      this.addBtn.dataset.variantId = option.value;
    } else if (this.currentCard) {
      const priceSource = this.currentCard.querySelector('[data-pot-price]');
      priceSlot.innerHTML = priceSource ? priceSource.innerHTML : '';
      this.addBtn.dataset.variantId = this.currentCard.dataset.variantId || '';
    }
  }

  apply() {
    if (!this.pendingCard) return;
    this.currentCard = this.pendingCard;
    this.renderSelected(this.currentCard);
    this.preview.hidden = true;
    this.selected.hidden = false;
    this.closeDrawer();
  }

  renderSelected(card) {
    const mediaSlot = this.selected.querySelector('[data-pot-selected-media]');
    const image = card.querySelector('.pot-card__image');
    mediaSlot.innerHTML = '';
    if (image) mediaSlot.appendChild(image.cloneNode(true));

    this.selected.querySelector('[data-pot-selected-title]').textContent = card.dataset.title || '';

    const variantSlot = this.selected.querySelector('[data-pot-selected-variant]');
    variantSlot.innerHTML = '';
    const cardSelect = card.querySelector('[data-pot-variant]');
    if (cardSelect) variantSlot.appendChild(cardSelect.cloneNode(true));

    this.syncSelectedVariant();
  }

  // Delete = doar deselectare: revine la preview, NU atinge cosul.
  deselect() {
    this.currentCard = null;
    this.pendingCard = null;
    this.cards.forEach((card) => card.classList.remove('is-selected'));
    this.selected.hidden = true;
    this.preview.hidden = false;
  }

  addToCart() {
    const variantId = this.addBtn.dataset.variantId;
    if (!variantId) return;

    const addUrl = this.dataset.addUrl;
    const miniCart = this.miniCart || document.querySelector('mini-cart');
    this.miniCart = miniCart;
    const cartDrawerEnabled = !!miniCart && !document.body.classList.contains('template-cart');

    if (!cartDrawerEnabled) {
      if (window.Shopify && Shopify.postLink) {
        Shopify.postLink(addUrl, { parameters: { id: variantId, quantity: 1 } });
      } else {
        window.location.href = window.routes ? window.routes.cart_url : '/cart';
      }
      return;
    }

    this.addBtn.setAttribute('disabled', '');
    this.addBtn.classList.add('loading');

    const sections = miniCart.getSectionsToRender().map((section) => section.id);
    const item = {
      id: variantId,
      quantity: 1,
      sections: sections,
      sections_url: window.location.pathname,
    };

    if (this.dataset.linkLabel && this.dataset.linkValue) {
      item.properties = { [this.dataset.linkLabel]: this.dataset.linkValue };
    }

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(item),
    })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.status) {
          console.error(parsedState.description || parsedState.message);
          return;
        }
        if (this.miniCart) this.miniCart.renderContents(parsedState);
      })
      .catch((error) => console.error(error))
      .finally(() => {
        this.addBtn.removeAttribute('disabled');
        this.addBtn.classList.remove('loading');
      });
  }
}

customElements.define('pot-picker', PotPicker);
